// extracted by mini-css-extract-plugin
export var breadcrumb = "_15-3";
export var breadcrumbArrow = "_15-4";
export var breadcrumbs = "_15-0";
export var link = "_15-5";
export var sm = "_15-1";
export var xs = "_15-2";